<template>
  <div class="activity-row">
    <div class="activity-label">
      <div class="activity-label--left">
        <slot name="icon"/>
      </div>
      <div class="activity-label--center">
        <slot name="title"/>
      </div>
      <div class="activity-label--right">
        <div
          v-if="isStatusClaim"
          class="reward claim"
          data-test="activity-template--label-claim"
        >
          <img src="/static/svg/reward-claim.svg">
        </div>
        <div
          v-else
          class="reward claim"
          data-test="activity-template--label-warning"
        >
          <img src="/static/svg/icon-warning.svg">
        </div>
      </div>
    </div>
    <div class="activity-description">
      <div class="text-box">
        <slot name="description"/>
      </div>
    </div>
    <div class="activity-button">
      <slot name="button"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityTemplate',
  props: {
    isStatusClaim: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-row {
  float: left;
  width: 100%;
  padding: 9px 0 9px 0;
  border-bottom: solid 1px #e4e4e4;
  &:last-child {
    border: none;
  }
}
.activity-label {
  float: left;
  width: 38%;
  &--left {
    float: left;
    width:auto;
  }
  &--center {
    float: left;
    width: 62%;
    margin-left: 10px;
    .head {
      font-size: 13px;
      font-weight: bold;
    }
  }
  &--right {
    float: right;
  }
}
.activity-description {
  float: left;
  width: 33%;
  font-size: 12px;
  color: #6b6b6b;
  margin-left: 21px;
}
.activity-button {
  float: right;
}
.reward {
  font-size: 12px;
  font-weight: 400;
  float: left;
  img {
    float: right;
    width: 20px;
    vertical-align: middle;
  }
  &.claim {
    color: #7ed321;
  }
  &.wating {
    color: #afafaf;
  }
}
.warning-text {
  color: #ff0000;
  font-size: 11px;
}
.reward {
  font-size: 12px;
  font-weight: 400;
  width: 100%;
  float: left;
  span {
    vertical-align: middle;
  }
  &.claim {
    color: #7ed321;
  }
  &.wating {
    color: #afafaf;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .activity-label, .activity-description {
    width: 100%;
    margin-left: unset;
  }
  .activity-button {
    padding-top: 15px;
  }
  .activity-label--center {
    .head {
      float: left;
      width: 100%;
    }
  }
  .text-box {
    margin-left: 43px;
    width: 75%;
  }
  .reward {
    float: none;
    width: 100%;
    margin-top: 12px;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/ActivityTemplate/index.vue